<template>
    <main class="main__sc__analysis__wrapper">
        <section class="sc__analysis__group__wrapper">
            <!-- Sidebar -->
            <aside class="sidebar__group__list__box">
                <div class="heading__title heading__title--with-toggle">
                    <h3 class="title">EESA Work Packet</h3>
                    <button
                        type="button"
                        class="guided-plan-toggle"
                        @click="switchToGuidedPlan"
                        title="Switch to the Guided Plan view"
                    >
                        <span class="material-symbols-outlined">auto_awesome</span>
                        <span class="guided-plan-toggle__label">Guided Plan</span>
                    </button>
                </div>
                <div class="tab__menu__item__box">
                    <ul id="tabs-nav">
                        <li v-for="(tab, index) in tabs" :key="index" :class="[
                            isTabActive(tab) ? 'active' : '',
                            tab.children ? 'dropdown__menu__tabs' : ''
                        ]">
                            <a href="javascript:void(0);" @click.prevent="handleTabClick(tab)">
                                {{ tab.label }}
                                <template v-if="tab.children">
                                    <img v-if="openDropdown == tab.id && (activeTab === tab.id || tab?.activeIds?.includes(activeTab))" class="dropdown__icon" :src="minusIcon" />
                                    <img v-else class="dropdown__icon"
                                        :src="plusIcon" />
                                </template>
                            </a>
                            <!-- Dropdown children -->
                            <ul v-if="tab.children && openDropdown == tab.id && (activeTab === tab.id || tab?.activeIds?.includes(activeTab))" class="dropdown__tab__group"
                                style="height: auto;">
                                <li class="sub__tab__item" v-for="(child, idx) in tab.children"
                                    :key="`${tab.id}-child-${idx}`" :class="{ active: activeTab === child.id }"
                                    @click.stop>
                                    <a href="javascript:void(0);" @click.prevent="setActive(child.id)">
                                        <span>{{ child.label }}</span>
                                    </a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>

                <div class="tab__btn__group">
                    <div class="purple__solid__btn">
                        <RouterLink :to="`/organizations/${organizationId}/learners/${learnerId}/dashboard`">
                            <span class="btn__icon">
                                <img :src="purpleArrow" />
                            </span>
                            <span class="btn__text">Back To Learner Dashboard</span>
                        </RouterLink>
                    </div>
                </div>
            </aside>

            <!-- Right Content -->
            <div class="sc__right__box__wrapper eesa__work__packet__wrapper">
                <Information v-if="activeTab === 'information'" :assessmentId="assessmentId"
                    :organizationId="organizationId" :learnerId="learnerId" />
                <AssessmentResult v-if="activeTab === 'result__summary'" :assessment="assessment" />
                <template v-if="['analysis_grp1', 'analysis_grp2', 'analysis_grp3'].includes(activeTab)">
                    <Analysis :assessmentId="assessmentId" :organizationId="organizationId" :learnerId="learnerId"
                        :group="activeAnalysisGroup" />
                </template>
                <template v-if="['target_grp1', 'target_grp2', 'target_grp3'].includes(activeTab)">
                    <TargetGuide :assessmentId="assessmentId" :organizationId="organizationId" :learnerId="learnerId"
                        :group="activeTargetGroup" />
                </template>
                <template v-if="['target-decision'].includes(activeTab)">
                    <TargetDecision :assessmentId="assessmentId" :organizationId="organizationId"
                        :learnerId="learnerId" />
                </template>
                <template v-if="['worksheet-a', 'worksheet-b'].includes(activeTab)">
                    <Worksheet :assessmentId="assessmentId" :organizationId="organizationId" :learnerId="learnerId"
                        :type="activeTab === 'worksheet-a' ? 'A' : 'B'" />
                </template>
                <MiniProgramPlan v-if="activeTab === 'MiniProgramPlan'" :assessmentId="assessmentId"
                    :organizationId="organizationId" :learnerId="learnerId"
                    :canConductAssessment="canConductAssessment" />
                <SyllableTracker v-if="activeTab === 'SyllableTracker'" :assessmentId="assessmentId"
                    :organizationId="organizationId" :learnerId="learnerId"
                    :canConductAssessment="canConductAssessment" />
                <PreferencesList v-if="activeTab === 'PreferencesList'" :assessmentId="assessmentId"
                    :organizationId="organizationId" :learnerId="learnerId"
                    :canConductAssessment="canConductAssessment" />
                <SkillsPreferences v-if="activeTab === 'SkillsPreferences'" :assessmentId="assessmentId"
                    :organizationId="organizationId" :learnerId="learnerId"
                    :canConductAssessment="canConductAssessment" />
                <ProgramTargets v-if="activeTab === 'ProgramTargets'" :assessmentId="assessmentId"
                    :organizationId="organizationId" :learnerId="learnerId"
                    :canConductAssessment="canConductAssessment" />
                <div class="programtargets_top_btn_wrapper rlms-flex rlms-justify-center rlms-w-100">
                    <div class="section__btn__block">
                        <button id="allTargetsSave" class="purple__save__btn" type="button" @click="prevTab"
                        :disabled="currentIndex === 0" :style="currentIndex === 0 ? 'opacity:0.5;cursor:not-allowed;' : ''" v-if="currentIndex > 0">Prev</button>
                    </div>
                    <div class="section__btn__block">
                        <button id="allTargetsSave" class="purple__save__btn" type="button" @click="nextTab"
                        :disabled="currentIndex === flatTabs.length - 1" :style="currentIndex === flatTabs.length - 1 ? 'opacity:0.5;cursor:not-allowed;' : ''" v-if="currentIndex !== flatTabs.length - 1">Next</button>
                    </div>
                </div>
            </div>
        </section>
    </main>
</template>

<script setup>
import AssessmentResult from '@/components/assesments/AssessmentResult.vue'
import Analysis from '@/components/assesments/workpacket/Analysis.vue';
import Information from '@/components/assesments/workpacket/Information.vue'
import MiniProgramPlan from '@/components/assesments/workpacket/MiniProgramPlan.vue';
import PreferencesList from '@/components/assesments/workpacket/PreferencesList.vue';
import ProgramTargets from '@/components/assesments/workpacket/ProgramTargets.vue';
import SkillsPreferences from '@/components/assesments/workpacket/SkillsPreferences.vue';
import SyllableTracker from '@/components/assesments/workpacket/SyllableTracker.vue';
import TargetDecision from '@/components/assesments/workpacket/TargetDecision.vue';
import TargetGuide from '@/components/assesments/workpacket/TargetGuide.vue';
import Worksheet from '@/components/assesments/workpacket/Worksheet.vue';
import api from '@/services/axios';
import { useLoaderStore } from '@/stores/loader';
import { handleError } from '@/utils/handleError';
import { showConfirmDialog } from '@/utils/swal';
import { computed, onMounted, provide, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router';
import plusIcon from '@/assets/images/plus-icon1.svg'
import minusIcon from '@/assets/images/minus-icon1.svg'
import purpleArrow from '@/assets/images/purple-btn-arrow-left.svg'

const route = useRoute();
const router = useRouter();
const activeTab = ref('information')
const assessment = ref(null)
const organization = ref(null)
const openDropdown = ref(null)
const organizationId = ref(Number(route.params.organization ?? 0));
const learnerId = ref(Number(route.params.learner ?? 0));
const assessmentId = ref(Number(route.params.assessment ?? 0));

const loader = useLoaderStore();

// Track unsaved changes from child components
const unsavedCheckFn = ref(null);
const registerUnsavedCheck = (checkFn) => {
    unsavedCheckFn.value = checkFn;
};
provide('registerUnsavedCheck', registerUnsavedCheck);

// Clear unsaved check when tab changes
watch(activeTab, () => {
    unsavedCheckFn.value = null;
});

const analysisGroupMap = {
    analysis_grp1: 1,
    analysis_grp2: 2,
    analysis_grp3: 3
};

const targetGroupMap = {
    target_grp1: 1,
    target_grp2: 2,
    target_grp3: 3
};

const activeAnalysisGroup = computed(() => analysisGroupMap[activeTab.value] || 1);
const activeTargetGroup = computed(() => targetGroupMap[activeTab.value] || 1);

// Unified sidebar structure
const tabs = [
    { label: 'Information', id: 'information' },
    { label: 'Result Summary', id: 'result__summary' },
    {
        label: 'Analysis',
        id: 'analysis',
        activeIds: ['analysis', 'analysis_grp1', 'analysis_grp2', 'analysis_grp3'],
        children: [
            { label: 'Group 1', id: 'analysis_grp1', dataItem: 'analysis_grp1item', dataCommon: 'analysis_grpitem' },
            { label: 'Group 2', id: 'analysis_grp2', dataItem: 'analysis_grp2item', dataCommon: 'analysis_grpitem' },
            { label: 'Group 3', id: 'analysis_grp3', dataItem: 'analysis_grp3item', dataCommon: 'analysis_grpitem' }
        ]
    },
    {
        label: 'Target Guide',
        id: 'target',
        activeIds: ['target', 'target_grp1', 'target_grp2', 'target_grp3'],
        children: [
            { label: 'Group 1', id: 'target_grp1', dataItem: 'target_grp1item', dataCommon: 'target_grpitem' },
            { label: 'Group 2', id: 'target_grp2', dataItem: 'target_grp2item', dataCommon: 'target_grpitem' },
            { label: 'Group 3', id: 'target_grp3', dataItem: 'target_grp3item', dataCommon: 'target_grpitem' }
        ]
    },
    { label: 'Starting Targets Decision Box', id: 'target-decision' },
    { label: 'Worksheet A', id: 'worksheet-a' },
    { label: 'Worksheet B', id: 'worksheet-b' },
    { label: 'Preferences List', id: 'PreferencesList' },
    { label: 'Mini - Program Plan', id: 'MiniProgramPlan' },
    { label: 'Syllable Tracker', id: 'SyllableTracker' },
    { label: 'Skills Preferences Match-Up', id: 'SkillsPreferences' },
    { label: 'Program Targets', id: 'ProgramTargets' }
]

const checkUnsavedAndProceed = async (proceedFn) => {
    if (unsavedCheckFn.value && unsavedCheckFn.value()) {
        const result = await showConfirmDialog({
            title: 'Unsaved Changes',
            html: 'You have unsaved changes. Are you sure you want to leave without saving?',
            confirmButtonText: 'Leave',
            cancelButtonText: 'Stay',
            icon: 'warning',
            confirmButtonColor: '#d33',
            cancelButtonColor: '#7c3aed',
        });
        if (result.isConfirmed) {
            proceedFn();
        }
    } else {
        proceedFn();
    }
};

const setActive = async (id) => {
    await checkUnsavedAndProceed(() => {
        activeTab.value = id;
    });
};

const handleTabClick = async (tab) => {
    const isOpen = openDropdown.value === tab.id;

    if (tab.children?.length) {
        openDropdown.value = isOpen ? null : tab.id;
        if (!isOpen) {
            const firstChildId = tab.children[0]?.id;
            if (firstChildId) {
                await checkUnsavedAndProceed(() => {
                    activeTab.value = firstChildId;
                });
            }
        }
    } else {
        await checkUnsavedAndProceed(() => {
            openDropdown.value = isOpen ? null : tab.id;
            activeTab.value = tab.id;
        });
    }
};

const isTabActive = (tab) =>
    tab.children?.some(child => child.id === activeTab.value) ||
    tab.id === activeTab.value;


const fetchAssessment = async () => {
    try {
        loader.show();
        const { data } = await api.get(`/organizations/${organizationId.value}/assessments/${assessmentId.value}`);
        assessment.value = data?.data || null
        organization.value = assessment.value?.learner?.organization || null
    } catch (error) {
        handleError(error);
    } finally {
        loader.hide();
    }
}

watch(activeTab, (newTab) => {
    if (newTab === 'result__summary') fetchAssessment();
});

onMounted(() => fetchAssessment());

const canConductAssessment = computed(() => {
    return assessment.value?.can_edit;
});

// Flattened version of tabs for sequential navigation
const flatTabs = computed(() => {
    const result = [];
    tabs.forEach(tab => {
        if (tab.children) {
            tab.children.forEach(child => {
                result.push({ parent: tab, ...child });
            });
        } else {
            result.push(tab);
        }
    });
    return result;
});

const currentIndex = computed(() =>
    flatTabs.value.findIndex(t => t.id === activeTab.value)
);

const nextTab = async () => {
    if (currentIndex.value < flatTabs.value.length - 1) {
        await checkUnsavedAndProceed(() => {
            activeTab.value = flatTabs.value[currentIndex.value + 1].id;
            openDropdown.value = flatTabs.value?.[currentIndex.value]?.parent?.id;
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    }
};

const prevTab = async () => {
    if (currentIndex.value > 0) {
        await checkUnsavedAndProceed(() => {
            activeTab.value = flatTabs.value[currentIndex.value - 1].id;
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    }
};

const switchToGuidedPlan = async () => {
    await checkUnsavedAndProceed(() => {
        router.push({
            name: 'LearnerWorkpacketGuided',
            params: {
                organization: organizationId.value,
                learner: learnerId.value,
                assessment: assessmentId.value,
            },
        });
    });
};
</script>

<style scoped>
.heading__title--with-toggle {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
}

.guided-plan-toggle {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: linear-gradient(135deg, #725CFF 0%, #9d8bff 100%);
    color: #fff;
    border: none;
    padding: 8px 14px;
    border-radius: 8px;
    font-weight: 500;
    font-size: 12px;
    cursor: pointer;
    transition: transform 0.15s, box-shadow 0.15s;
    box-shadow: 0 2px 6px rgba(114, 92, 255, 0.3);
    width: fit-content;
}

.guided-plan-toggle:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 10px rgba(114, 92, 255, 0.4);
}

.guided-plan-toggle .material-symbols-outlined {
    font-size: 16px;
}
</style>
